import classNames from 'classnames';
import React, { ChangeEvent } from 'react';
import { SecondaryTypography } from '../../typography/typography';
import styles from '../input.module.css';

type TextAreaProps = {
  label?: string;
  name: string;
  value: string;
  onChange: (event: ChangeEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
  customClass?: string;
  rows?: number;
  placeholder?: string;
};

export const TextArea = ({
  label,
  name,
  value,
  onChange,
  disabled,
  customClass,
  rows,
  placeholder,
}: TextAreaProps) => (
  <div className='w-full'>
    { label && (
      <label
          htmlFor={name}
          className='block mb-1 text-[11px] font-semibold text-slate-500 uppercase tracking-wider ml-0.5'
      >
        { label }
      </label>
    ) }
    <textarea
        id={name}
        name={name}
        className={classNames(
          'w-full px-3 py-2 text-[13px] bg-white border rounded-lg outline-none transition-all duration-200 min-h-[80px]',
          'placeholder:text-slate-400 placeholder:text-xs',
          disabled
            ? 'cursor-not-allowed bg-slate-50 text-slate-400 border-slate-200'
            : 'border-slate-200 hover:border-slate-300 focus:border-emerald-500 focus:ring-4 focus:ring-emerald-500/10',
          customClass,
        )}
        onChange={onChange}
        value={value}
        disabled={disabled}
        rows={rows ?? 3}
        placeholder={placeholder}
    />
  </div>
);
